import axios from "axios";
import React, {Component} from "react";
import StaffForm from "../components/StaffForm";
import Loading from "../components/Loading";
import { Link } from "react-router-dom";
import Profil from "./Profil";
import PageNav from "../partials/PageNav";

class Staff extends Component{

    state = {
        isModal : false,
        formData : null,
        staffs : [],
        loading : false
    }

    componentDidMount(){
        this.getStaffs();
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async getStaffs(){
        this.setState({
            loading : false
        })

        var society = localStorage.getItem("society") ?  JSON.parse(localStorage.getItem("society")) : {};
        society = society.userprofile ?  society.userprofile.profile ? society.userprofile.profile.society ? society.userprofile.profile.society.id : null : null : null;
      
        var staffs = await axios.get('staffs/' + society);
        if(staffs.status === 200)
        {
            this.setState({staffs : staffs.data, loading : true})
        }
    }

    showModal = (user = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : user,
        })
        this.getStaffs()
    }

    delete = (user) =>{
        axios.delete("users/" + user).then((response) => {
            this.getStaffs()
        }).catch((error)=>{})
    }

    handleCheck(val) {
        var permissions = JSON.parse(localStorage.getItem("permissions")) ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some(item => val === item.name)
    }

    render(){
        let pageNav = PageNav( "Staff" ,  "/staffs/",  "/logo192.png",  "Staff",  "Liste staff" );
        
        var staffs =
        this.state.staffs.map((user, count) => {
                return(

                    <div className="col-md-3 overflow-hidden" key={user.id}>
                    <div className="card shadow bg-white mb-2">
                        <div className="card-body pb-0">
                             
                            <Link to={"/teams/" + user.id }  className="text-decoration-none">
                                <img src={ user.avatar } className="img-thumbnail"  style={{ width : 307 +"px", height : 320 + "px" }} />
                            </Link>
                            <div className="ms-2 mt-2">
                                <div className="text-end small text-danger">{  user.userprofile ? user.userprofile.profile ? user.userprofile.profile.name : "staff" : "staff" }</div>
                                <div className="">{  user.name  }</div>
                                <div><a href={"tel:"+  user.tel  }  target="_blank" className="text-dark text-decoration-none me-2"> <i className="bi bi-phone text-primary"></i> {  user.tel  }</a> <br />
                                 <a href={"mailto:"+ user.email }  target="_blank" className="text-dark text-capitalize text-decoration-none"> <i className="bi bi-envelope text-danger"></i> { user.email}</a> </div>
                                <div><Link to={"/teams/" + user.id } className="text-dark text-capitalize text-decoration-none"> <i className="bi bi-flag text-warning"></i> { user.adress}</Link></div>
                                <div><Link to={"/teams/" + user.id } className="text-dark text-capitalize text-decoration-none font-10 small"> <i className="bi bi-clock text-danger"></i> <small>{ new Date( user.updatedAt ).toUTCString() }</small></Link></div>
                            </div>
                                
                            <div className="float-end">
                            {(this.handleCheck("modifier utilisateur") == true) && (
                            <a href="#" onClick={ () => this.showModal(user)}><i className="bi bi-pen text-primary font-16 me-3" ></i></a>
                            )}

                            {(this.handleCheck("supprimer utilisateur") == true) && (
                                <a href="#" onClick={() => this.delete(user.id)}><i className="bi bi-trash text-danger font-16"></i></a>
                            )}
                            </div>   
                        </div>
                    </div>
                </div>
                

                )
        })
        return(
            <main id="main">
                { pageNav }
                <div className="container">
                    <div className="row col-sm-12">
                      <div className="page-title-box">
                              {
                                  this.handleCheck("ajouter utilisateur") == true && (
                                      <div className="btn-toolbar mb-2 mb-md-0 d-end float-end">
                                          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><i className="bi bi-plus font-18"></i> Nouveau utilisateur</button>
                                      </div>
                                  )
                              }
                      </div>
                      {
                          !this.state.loading && (<Loading /> )
                      }
                </div>
                <div className="col-12">
                    <div className="border bg-white p-1 m-1"><Profil /></div>
                    <div className="card-body row">
                            
                        { staffs }
                                
                    </div>
                </div>

              </div>

            <StaffForm
                isModal={this.state.isModal}
                formData={this.state.formData}
                showModal={this.showModal}
            />

      </main>
        )
    }
}
export default Staff;
